'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var GlobalStyleTagBase = require('@narvar/nth-bit-global-style-tag');
var useTrackSettings = require('../providers/useTrackSettings.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var GlobalStyleTagBase__default = /*#__PURE__*/_interopDefaultLegacy(GlobalStyleTagBase);

// We're currently just taking the globalScopeCSS value from track (narvarjs)
const GlobalStyleTag = () => /*#__PURE__*/React__default["default"].createElement(useTrackSettings.LomaTrackSettingsProvider, null, /*#__PURE__*/React__default["default"].createElement(GlobalStyleTagBase__default["default"], null));

exports["default"] = GlobalStyleTag;
